export default {
  packsreceipts: {
    title: "Packs",
    info: {
      modal: {
        title: {
          vagueReadings: "Receipts with vague readings",
          deletedPacksPeriodWith: "Deleted posted packs for the period from",
          deletedPacksPeriodBy: "to"
        }
      }
    },
    editForm: {
      modal: {
        title: {
          packageInfo: "Pack info",
          compensationVisually: "Compensation for the visually impaired",
          socialSupplementInfo: "Social payment info",
          grantInfo: "Subsidy Information"
        }
      },
      form: {
        packnumber: "Pack bank number",
        datebank: "Bank date",
        codefirme: "Sender",
        accountSender: "Sender account",
        kindpay: "Payment method",
        summa: "Amount",
        sumprof: "For services",
        userid: "Operator",
        quantity: {
          numberSubscribers: "Number of subscribers",
          numberReceipts: "Number of receipts"
        },
        countband: {
          numberSheets: "Number of sheets",
          numberCountband: "Number of parcels"
        },
        addPayment: "Immediately enter a receipt for this bundle?"
      }
    },
    uploadForm: {
      modal: {
        title: "Files upload"
      },
      form: {
        uploadfile: "Files to upload"
      }
    },
    import: {
      modal: {
        title: {
          payments: "Import of payments",
          subsidies: "Import of subsidies"
        }
      },
      form: {
        codeimport: "Input type",
        kindpay: "Payment method",
        codepayRadio: {
          title: "The purpose of the payment",
          file: "Taken from the file",
          customer: "Set your own"
        },
        fileinfo: "File info"
      },
      result: {
        success: "Successful",
        error: "Error"
      }
    },
    confirmDateBank: {
      modal: {
        title: "Check bank date"
      },
      form: {
        description:
          "Check that the bank date specified in the imported bundle is correct",
        dateBank: "Bank date"
      },
      importError: "Bank date check not completed"
    },
    confirmSender: {
      modal: {
        title: "Sender organization"
      },
      form: {
        orgSendPack: "Select the organization that sent the pack",
        rcount: "account"
      }
    },
    confirmSenderMfo: {
      modal: {
        title: "Sender organization"
      },
      form: {
        mfo: "MFI",
        orgSendPack: "Select the organization that sent the pack",
        rcount: "account"
      }
    },
    confirmDestLink: {
      modal: {
        title: "Destination link description",
        description:
          "Specify which of the payment purposes corresponds to the payment with the name:",
        code: "code",
        additionallyImport: "Additionally, when importing such a payment",
        additionallyMeterReading: "add meter readings, if specified"
      },
      importError:
        "Error importing! The purpose of the payment is not indicated."
    },
    confirmSenderMfoNumber: {
      modal: {
        title: "Sender organization",
        description: "Select the organization that sent the pack",
        mfo: "MFO",
        number: "Number"
      },
      importError:
        "Error importing! The organization that sent the bundle is not specified."
    },
    statusModify: {
      add: "Addition",
      edit: "Editing",
      delete: "Marking for deletion"
    },
    confirmImport: {
      title: "Import"
    },
    importFiles: {
      error: "Violation of the registry structure in the file",
      sender: "Sender",
      datapack: "Date",
      countpack: "Number",
      summapack: "Notal",
      kompack: "Commission",
      denyChangeListFiles:
        "Changing the list of files after import is not possible",
      importedFiles: "Imported files: {files}",
      noAvailableImportFiles: "No files available for import",
      alert: {
        message: "Pack import completed",
        title: "Import"
      }
    },
    postingBtn: {
      confirm: {
        postingPack: "Posting Pack",
        summaPack: "by amount",
        senderPack: "sender",
        title: "Posting"
      }
    }
  }
};
